import axios from "axios";
import RestApi from "../../../utils/RestApi";
import {Fixture} from "../records/Fixture";

class FixtureApi
{
    public async getFixture(fixtureId: number): Promise<Fixture>
    {
        let url = await RestApi.getUrl(`/v1/fixtures/${fixtureId}`);

        const result = await axios.get(url);

        if (result.status !== 200)
        {
            throw new Error("Getting fixture failed");
        }

        return result.data as Fixture;
    }

    public async getFixtures(from: number, to: number): Promise<any>
    {
        let resultFixtures : Fixture[] = [];
        let page = 1;
        let totalFixtures = 0;
        let fixturesReceived = 50;

        while (fixturesReceived == 50)
        {
            let url = await RestApi.getUrl("/v1/fixtures?from=" + from + "&to=" + to + "&page=" + page);
            const result = await axios.get(url);

            if (result.status !== 200)
            {
                throw new Error("Getting fixture failed");
            }

            fixturesReceived = result.data.fixtures.length;
            totalFixtures += fixturesReceived;
            resultFixtures = resultFixtures.concat(result.data.fixtures);
            page++;
        }

        return {fixtures: resultFixtures, totalCount: totalFixtures};
    }

}

export default new FixtureApi();
